import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { white, text, info, secondary } = colors;
const { size } = typography;

const contained = {
  base: {
    backgroundColor: white.main,
    minHeight: pxToRem(40),
    color: text.main,
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    "&:hover": {
      backgroundColor: white.main,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: colors.primary.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.primary.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.primary.focus,
      color: `${white.main} !important`,
    },
  },

  secondary: {
    backgroundColor: secondary.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: secondary.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: secondary.focus,
      color: `${white.main} !important`,
    },
  },

  success: {
    backgroundColor: colors.success.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.success.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.success.focus,
      color: `${white.main} !important`,
    },
  },

  warning: {
    backgroundColor: colors.warning.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.warning.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.warning.focus,
      color: `${white.main} !important`,
    },
  },

  error: {
    backgroundColor: colors.error.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: colors.error.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.error.focus,
      color: `${white.main} !important`,
    },
  },

  info: {
    backgroundColor: info.main,
    color: `${white.main} !important`,

    "&:hover": {
      backgroundColor: info.focus,
      color: `${white.main} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: info.focus,
      color: `${white.main} !important`,
    },
  },
};

export default contained;
